export const APPLICATION_SECTION_SUMMARY = "summary";
export const APPLICATION_SECTION_PAYMENT_SUMMARY = "payment-summary";

export function applicationSectionTitle(
  sectionName: string | undefined,
  uiSchema: unknown,
  t: (key: string) => string,
  isApplicantToPay = false
) {
  if (sectionName === APPLICATION_SECTION_SUMMARY) {
    return isApplicantToPay ? t("Review and Confirm") : t("Review & Submit");
  }
  if (sectionName === APPLICATION_SECTION_PAYMENT_SUMMARY) {
    return t("Payment details");
  }

  if (
    uiSchema &&
    typeof uiSchema === "object" &&
    "elements" in uiSchema &&
    Array.isArray(uiSchema.elements)
  ) {
    const elements = uiSchema.elements as {
      name?: string;
      label?: string;
    }[];
    const match = elements.find((section) => section.name === sectionName);
    if (match?.label) {
      return match.label;
    }
  }

  return t("Application");
}
